import { ReactElement } from 'react';
import { ContentBlock } from '../../../components/layout/ContentBlock';
import { ContentCard } from './styles';
import Title from './Title';
import CallRequestForm from './CallRequestForm';

const Content = (): ReactElement => {
  return (
    <ContentBlock>
      <ContentCard>
        <Title />
        <CallRequestForm />
      </ContentCard>
    </ContentBlock>
  );
};

export default Content;
